const baseURL = "/v1/Perfil";

const service = {
  methods: {
    $buscarPerfis(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarPerfil({ id, params}) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },    
    $detalharUsoPerfil({ id, params}) {
      return this.$api().get(`${baseURL}/DetalharUso/${id}`, params);
    },
    $cadastrarPerfil(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarPerfil(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarPerfil(body, id) {
      return this.$api().patch(`${baseURL}/AlterarStatus/${id}`, body);
    },
    $excluirPerfil(body, id) {
      return this.$api().delete(`${baseURL}/${id}`, body);
    },
    $atribuirPerfilEmLote(body, id) {
      return this.$api().post(`${baseURL}/${id}/AtribuirEmLote`, body);
    },
    $atribuirPerfil(body) {
      return this.$api().post(`${baseURL}/Atribuir`, body);
    }
  },
};

export default service;
